// Listings page translations - EN/FR

export const LISTINGS_TRANSLATIONS = {
  en: {
    // Page header
    title: "Deal Monitor",
    subtitle: "Browse and monitor available business acquisition opportunities",
    tagline: "KEEP GROWING WITH US",
    sign_in: "Sign In",
    
    // Filters section
    filter_title: "Filter Deals",
    filter_subtitle: "Refine your search to find the perfect acquisition opportunity",
    
    // Filter labels
    search: "Search",
    search_placeholder: "Search by name, description, or listing #...",
    industry: "Industry",
    location: "Location",
    city_search: "City Search",
    city_search_placeholder: "Search by city...",
    price_min: "Min Price",
    price_max: "Max Price",
    min_ebitda: "Min EBITDA",
    max_ebitda: "Max EBITDA",
    min_cash_flow: "Min Cash Flow",
    max_cash_flow: "Max Cash Flow",
    status: "Status",
    special_filters: "Special Filters",
    
    // Industry options
    all_industries: "All Industries",
    industry_restaurant: "Restaurant",
    industry_technology: "Technology",
    industry_construction: "Construction",
    industry_healthcare: "Healthcare",
    industry_ecommerce: "E-commerce",
    industry_manufacturing: "Manufacturing",
    industry_agriculture: "Agriculture",
    industry_beauty: "Beauty & Wellness",
    industry_retail: "Retail",
    industry_education: "Education",
    industry_entertainment: "Entertainment",
    industry_financial: "Financial Services",
    industry_transport: "Transportation",
    
    // Location options
    all_locations: "All Locations",
    canada: "Canada",
    usa: "United States",
    canada_provinces: "🇨🇦 Canada - Provinces",
    usa_states: "🇺🇸 United States - States",
    
    // Price range options
    no_minimum: "No Minimum",
    no_maximum: "No Maximum",
    less_than_500k: "Less than $500K",
    
    // Status options
    status_active: "Active",
    status_pending: "Pending",
    status_sold: "Sold",
    status_all: "All",
    
    // Special filters options
    special_none: "None",
    special_seller_financing: "Seller Financing",
    special_e2_visa: "E2 Visa Eligible",
    special_pre_financing: "Pre-financing Available",
    special_absentee_owner: "Absentee Owner",
    special_semi_absentee: "Semi-Absentee Owner",
    special_home_based: "Home-Based",
    special_selected: "{count} selected",
    special_select_filters: "Select filters...",
    
    // Actions
    clear_filters: "Clear Filters",
    apply_filters: "Apply",
    active_filters: "Active filters",
    preview_results: "{count} results",
    location_search: "Location",
    location_placeholder: "Search city, province, state...",
    
    // Results
    showing_results: "Showing {count} of {total} deals",
    
    // Card labels
    cash_flow: "Cash Flow",
    sde: "SDE",
    pre_financing_offers: "pre-financing offers",
    seller_financing: "Seller Financing",
    e2_visa: "E2 Visa",
    listing_number: "Listing #",
    
    // Favorites
    added_to_favorites: "Added to favorites ❤️",
    removed_from_favorites: "Removed from favorites",
    
    // Listing titles (EN)
    listing_001_title: "Established Fast Food Franchise",
    listing_001_description: "Well-established franchise in premium location with high traffic. Over 15 years of operation. Stable team of 18 employees. Growth opportunity with expanding delivery services.",
    listing_002_title: "B2B Project Management SaaS Platform",
    listing_002_description: "Profitable SaaS platform with 850+ active clients. Monthly recurring revenue (MRR) of $95K. 94% retention rate. Modern and scalable technology. Technical team of 8 people.",
    listing_003_title: "Residential and Commercial Construction Company",
    listing_003_description: "Construction company established for 22 years. Diversified project portfolio. Modern equipment included (value of $400K). Contracts signed for 18 months. Excellent local reputation.",
    listing_004_title: "Multi-Practitioner Dental Clinic",
    listing_004_description: "Modern dental clinic with 3 dentists and support staff. Loyal patient base of 2,500+. State-of-the-art equipment. Strategic location with parking. Consistent annual growth of 8%.",
    listing_005_title: "Online Store - Natural Beauty Products",
    listing_005_description: "Established e-commerce with strong brand and loyal customer base. Over 15,000 annual orders. Presence on Amazon and Shopify store. Inventory included. Gross margins of 65%. Advanced automation.",
    listing_006_title: "Specialized Automotive Parts Manufacturer",
    listing_006_description: "Established manufacturer with 30 years of experience. Long-term contracts with major automakers. 45,000 sq ft facilities with modern CNC equipment. ISO 9001 and IATF 16949 certified.",
    
    // Categories
    category_technology: "TECHNOLOGY",
    category_healthcare: "HEALTHCARE",
    category_manufacturing: "MANUFACTURING",
  },
  fr: {
    // Page header
    title: "Surveillance des Transactions",
    subtitle: "Parcourir et surveiller les opportunités d'acquisition d'entreprises disponibles",
    tagline: "GRANDISSEZ AVEC NOUS",
    sign_in: "Connexion",
    
    // Filters section
    filter_title: "Filtrer les Opportunités",
    filter_subtitle: "Affinez votre recherche pour trouver l'opportunité d'acquisition parfaite",
    
    // Filter labels
    search: "Recherche",
    search_placeholder: "Rechercher par nom, description ou # d'annonce...",
    industry: "Secteur d'Activité",
    location: "Emplacement",
    city_search: "Recherche par Ville",
    city_search_placeholder: "Rechercher par ville...",
    price_min: "Prix Min",
    price_max: "Prix Max",
    min_ebitda: "EBITDA Min",
    max_ebitda: "EBITDA Max",
    min_cash_flow: "Flux Trésorerie Min",
    max_cash_flow: "Flux Trésorerie Max",
    status: "Statut",
    special_filters: "Filtres Spéciaux",
    
    // Industry options
    all_industries: "Tous les Secteurs",
    industry_restaurant: "Restauration",
    industry_technology: "Technologie",
    industry_construction: "Construction",
    industry_healthcare: "Santé",
    industry_ecommerce: "Commerce en Ligne",
    industry_manufacturing: "Fabrication",
    industry_agriculture: "Agriculture",
    industry_beauty: "Beauté & Bien-être",
    industry_retail: "Commerce de Détail",
    industry_education: "Éducation",
    industry_entertainment: "Divertissement",
    industry_financial: "Services Financiers",
    industry_transport: "Transport",
    
    // Location options
    all_locations: "Tous les Emplacements",
    canada: "Canada",
    usa: "États-Unis",
    canada_provinces: "🇨🇦 Canada - Provinces",
    usa_states: "🇺🇸 États-Unis - États",
    
    // Price range options
    no_minimum: "Pas de minimum",
    no_maximum: "Pas de maximum",
    less_than_500k: "Moins de 500K$",
    
    // Status options
    status_active: "Actif",
    status_pending: "En attente",
    status_sold: "Vendu",
    status_all: "Tous",
    
    // Special filters options
    special_none: "Aucun",
    special_seller_financing: "Financement Vendeur",
    special_e2_visa: "Éligible Visa E2",
    special_pre_financing: "Pré-financement Disponible",
    special_absentee_owner: "Propriétaire Absent",
    special_semi_absentee: "Propriétaire Semi-Absent",
    special_home_based: "À Domicile",
    special_selected: "{count} sélectionné(s)",
    special_select_filters: "Sélectionner filtres...",
    
    // Actions
    clear_filters: "Effacer les Filtres",
    apply_filters: "Appliquer",
    active_filters: "Filtres actifs",
    preview_results: "{count} résultats",
    location_search: "Emplacement",
    location_placeholder: "Rechercher ville, province, état...",
    
    // Results
    showing_results: "Affichage de {count} sur {total} opportunités",
    
    // Card labels
    cash_flow: "Flux de Trésorerie",
    sde: "SDE",
    pre_financing_offers: "offres de pré-financement",
    seller_financing: "Financement Vendeur",
    e2_visa: "Visa E2",
    listing_number: "Annonce #",
    
    // Favorites
    added_to_favorites: "Ajouté aux favoris ❤️",
    removed_from_favorites: "Retiré des favoris",
    
    // Listing titles (FR)
    listing_001_title: "Franchise de Restauration Rapide Établie",
    listing_001_description: "Franchise bien établie dans un emplacement premium avec fort achalandage. Plus de 15 ans d'opération. Équipe stable de 18 employés. Opportunité de croissance avec services de livraison en expansion.",
    listing_002_title: "Plateforme SaaS B2B de Gestion de Projets",
    listing_002_description: "Plateforme SaaS rentable avec 850+ clients actifs. Revenus récurrents mensuels (MRR) de 95K$. Taux de rétention de 94%. Technologie moderne et scalable. Équipe technique de 8 personnes.",
    listing_003_title: "Entreprise de Construction Résidentielle et Commerciale",
    listing_003_description: "Entreprise de construction établie depuis 22 ans. Portfolio de projets diversifié. Équipement moderne inclus (valeur de 400K$). Contrats signés pour 18 mois. Excellente réputation locale.",
    listing_004_title: "Clinique Dentaire Multi-Praticiens",
    listing_004_description: "Clinique dentaire moderne avec 3 dentistes et personnel de soutien. Base de patients fidèles de 2 500+. Équipement à la fine pointe. Emplacement stratégique avec parking. Croissance annuelle constante de 8%.",
    listing_005_title: "Commerce en Ligne - Produits de Beauté Naturels",
    listing_005_description: "E-commerce établi avec marque forte et base de clients fidèles. Plus de 15 000 commandes annuelles. Présence sur Amazon et boutique Shopify. Inventaire inclus. Marges brutes de 65%. Automatisation avancée.",
    listing_006_title: "Fabricant de Pièces Automobiles Spécialisées",
    listing_006_description: "Fabricant établi avec 30 ans d'expérience. Contrats long-terme avec constructeurs automobiles majeurs. Installations de 45 000 pi² avec équipement CNC moderne. Certifications ISO 9001 et IATF 16949.",
    
    // Categories
    category_technology: "TECHNOLOGIE",
    category_healthcare: "SANTÉ",
    category_manufacturing: "FABRICATION",
  },
};

export type ListingsTranslations = typeof LISTINGS_TRANSLATIONS.en;
export type Language = 'en' | 'fr';

export const getListingsTranslations = (lang: Language): ListingsTranslations => {
  return LISTINGS_TRANSLATIONS[lang];
};
